module.exports = __webpack_public_path__ + "img/Presentation3_old.7a8b4bbd.png";